import Column from '@components/Column';
import Filter from '@components/Filter';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { StampCardSorter } from '@models/stamp';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { stampCardSorterAtom } from '../../atoms/stampAtoms';

function StampHeader() {
    const { t } = useTranslation('stamp');
    const [sort, setSort] = useAtom(stampCardSorterAtom);

    return (
        <Container fullWidth spacing={28}>
            <Filter title={t('filter.title')}
                css={filterCss}
                sort={sort}
                setSort={setSort}
                sortItems={[
                    { value: StampCardSorter.IssuedAtDesc, label: t('filter.recentOrder') },
                    { value: StampCardSorter.ShopNameAsc, label: t('filter.alphabetOrder') },
                ]} />
        </Container>
    );
}

const Container = styled(Column)`
    padding: 36px 44px 20px 20px;
    position: relative;
`;

const filterCss = css`
    padding: 0 !important;
`;

export default StampHeader;
